var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.JSStorage = new Class({
    protected_keys: ["setItem", "getItem", 'removeItem', "key"],
    storage: {},
    length: 0,
    setItem: function (key, value) {
        if (value === null && this.storage.hasOwnProperty(key)) {
            delete this.storage[key];
        } else {
            this.storage[key] = value;
        }
        this.length = Object.keys(this.storage).length;
    },
    getItem: function (key) {
        if (this.storage.hasOwnProperty(key)) {
            return this.storage[key];
        }
    },
    removeItem: function (key) {
        if (this.storage.hasOwnProperty(key)) {
            delete this.storage[key];
            this.length = Object.keys(this.storage).length;
        }
    },
    key: function (i) {
        return Object.keys(this.storage)[i];
    }
});